import { render, staticRenderFns } from "./TextareaCom.vue?vue&type=template&id=02b194d6&scoped=true&"
import script from "./TextareaCom.vue?vue&type=script&lang=js&"
export * from "./TextareaCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b194d6",
  null
  
)

export default component.exports